import { render, staticRenderFns } from "./zoomableImage.vue?vue&type=template&id=27c0f684&scoped=true&"
import script from "./zoomableImage.vue?vue&type=script&lang=js&"
export * from "./zoomableImage.vue?vue&type=script&lang=js&"
import style0 from "./zoomableImage.vue?vue&type=style&index=0&id=27c0f684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c0f684",
  null
  
)

export default component.exports